// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
import contextMenu from './modules/contextMenu'
import onboarding from './modules/onboarding'
import planner from './modules/planner'
import postCreator from './modules/postCreator'
import selectPage from './modules/selectPage'
import storification from './modules/storification'
import tooltip from './modules/tooltip'
import tours from './modules/tours'
import users from './modules/users'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    selectPage,
    tooltip,
    contextMenu,
    postCreator,
    storification,
    users,
    planner,
    onboarding,
    tours
  }
})
